module.exports = __webpack_public_path__ + "static/media/req-workspace-buyer-lawyer-help2.97298ca4.svg";